var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isAfter(_vm.finalBegin))?_c('div',{staticClass:"stage-final"},[(_vm.isAfter(_vm.finalRes))?_c('final-result'):(_vm.isAfter(_vm.finalEnd))?_c('final-ended'):_c('final-playing')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }